import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TripRequestService } from 'src/app/service/trip-request/trip-request.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-cancel',
  templateUrl: './cancel.component.html',
  styleUrls: ['./cancel.component.css'],
})
export class CancelComponent implements OnInit {
  solicitationId: number;
  loading: boolean;
  cancelForm: FormGroup;
  data;

  constructor(
    private service: TripRequestService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.route.params.subscribe((params) => {
      this.solicitationId = params['id'];
    });
  }

  ngOnInit(): void {
    this.createForm();
    this.service.getTripRequest(this.solicitationId).subscribe((data) => {
      this.data = data;

      if (this.data.status != 'waiting' && this.data.status != 'rejected') {
        Swal.fire(
          'Atenção!!',
          'Só é possivel cancelar Solicitações com Status de Aguardando ou Rejeitada!!',
          'warning'
        );
        this.router.navigate(['process/trip-request']);
      }
    });
  }

  createForm() {
    this.cancelForm = this.fb.group({
      motive: ['', [Validators.required, Validators.maxLength(80)]],
      description: ['', Validators.required],
    });
  }

  onSubmit() {
    this.loading = true;
    const { controls } = this.cancelForm;

    const data = {
      motive: controls.motive.value,
      description: controls.description.value,
    };

    this.service.cancel(data, this.solicitationId).subscribe(
      (data) => {
        Swal.fire(
          'Cancelado',
          'Agendamento de Corrida Cancelada com Sucesso!!',
          'success'
        );
        this.loading = false;
        this.router.navigate(['process/trip-request']);
      },
      (error) => {
        this.loading = false;
        Swal.fire('Erro', 'Erro ao Cancelar Agendamento de Corrida!!', 'error');
      }
    );
  }
}
